import type { InsuranceIndex } from '../../../types/InsuranceFeatureConfig';
import type { HealthFeatureConfig } from '../../../types/insurances/HealthFeatureConfig';
import { health as base } from './base';
import { health as AT } from './AT';
import { health as HR } from './HR';
import { health as HU } from './HU';
import { health as RO } from './RO';

export const healthConfig: InsuranceIndex<HealthFeatureConfig> = { base, AT, HR, HU, RO };
